import React from 'react';
import { Link } from "react-router-dom";

export const CallToAction = () => {
    return (
        <div className="flex gap-6 w-full">
            <div className="w-3/6"><Link to=""><img src="images/callus.jpg" alt="Call" /></Link></div>
            <div className="w-3/6"><Link to=""><img src="images/chat-wa.jpg" alt="WhatsApp" /></Link></div>
        </div>
    )
}
